module.exports = __webpack_public_path__ + "img/case.9b2935a.svg";